"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _all = require("animations-json/build/all");

var _LottieAnimationBase = _interopRequireDefault(require("../LottieAnimationBase"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Animation20 = /*#__PURE__*/function (_AnimationBase) {
  _inherits(Animation20, _AnimationBase);

  var _super = _createSuper(Animation20);

  function Animation20(animObj) {
    var _this;

    _classCallCheck(this, Animation20);

    var animationId = animObj.animationId,
        data = animObj.data;
    var config = {
      default: {
        colors: ['#fff', 'rgb(50, 186, 250)']
      },
      maxCharInline: 1000,
      minLines: 1,
      maxLines: 6,
      lineHeight: {
        base: 110,
        extra: 68
      },
      width: 660,
      height: 450,
      textShadow: [1],
      inDuration: 800,
      intermissionDuration: 3000,
      outDuration: 800,
      totalDuration: 4600
    };
    _this = _super.call(this, animObj, data, config);
    var animation = (0, _all.getAnimationJson)(animationId); // set colors
    // replace with color 1

    var fontOneColorPattern = new RegExp('"fc":\\[1,1,1]', 'g');
    var shapeColorPattern1 = new RegExp('\\[0.196078431373,0.729411764706,0.980392156863,1]', 'g');
    animation = animation.replace(fontOneColorPattern, "\"fc\":[".concat(_this.colors[0], "]")).replace(shapeColorPattern1, "[".concat(_this.colors[1], "]"));

    if (_this.lines.length === 1) {
      _this.lines.unshift('');
    }

    for (var i = 0; i < config.maxLines; i++) {
      var line = _this.lines.length > i ? _this.lines[i] : '';
      animation = animation.replace("{#DYNAMICINPUT_0".concat(i + 1, "#}"), line);
    } // update fonts list for this annimation


    if (_this.fonts && _this.fonts.length > 0 && _this.fonts.length < 2) {
      var font = _objectSpread({}, _this.fonts[0]);

      _this.fonts.push(font);
    } // parse string to object


    _this.json = JSON.parse(animation);
    return _this;
  }

  return Animation20;
}(_LottieAnimationBase.default);

exports.default = Animation20;